export const clampIsoDateYear = (value = "") => {
  if (!value) return value;
  const stringValue = String(value);
  const endsWithDash = stringValue.endsWith("-");
  const parts = stringValue.split("-");
  const [rawYear = "", ...restParts] = parts;
  const digitsOnlyYear = rawYear.replace(/\D/g, "");
  const constrainedYear = digitsOnlyYear.slice(0, 4);

  const rest = restParts.join("-");
  let nextValue = constrainedYear;

  if (rest) {
    nextValue = `${nextValue}-${rest}`;
  } else if (endsWithDash && parts.length > 1) {
    nextValue = `${nextValue}-`;
  }

  return nextValue;
};

export const hasFourDigitYear = (value = "") => {
  if (!value) return false;
  const [rawYear = ""] = String(value).split("-");
  const digitsOnlyYear = rawYear.replace(/\D/g, "");
  return digitsOnlyYear.length === 4;
};
